/**
 * Sound commands are the easter-egg slash commands a post or comment may open
 * with (`/wetpants hello`): the mobile app plays a sound for them. They are
 * meant to be found, not advertised, so no surface shows the command to people.
 * It is stored as part of the text, so everything that shows post or comment
 * text takes it off: `renderPostContent` puts a speaker icon in its place, and
 * plain-text surfaces (one-line labels, page titles, meta descriptions) drop it
 * with `withoutSoundCommand`.
 *
 * Same list and rule as the server's `common.SoundCommands` /
 * `common.WithoutSoundCommand` (server/domain/common/notification_text.go).
 */
const SOUND_COMMANDS = [
  '/wetpants',
  '/musicpants',
  '/sharppants',
  '/normalpants',
  '/widepants',
] as const

/**
 * Go's `unicode.IsSpace` set, spelled out because JS `\s` differs from it
 * (`\s` adds U+FEFF and lacks U+0085).
 */
const LEADING_SPACE = /^[\t\n\v\f\r \u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]+/

/**
 * Drops a sound command from the very start of `text`, with the whitespace
 * after it. A command anywhere else is ordinary text.
 */
export function withoutSoundCommand(text: string): string {
  for (const command of SOUND_COMMANDS) {
    if (text.startsWith(command)) {
      return text.slice(command.length).replace(LEADING_SPACE, '')
    }
  }
  return text
}
